import { TowingRecordStatus } from '../../common/types'
import { TowingRecord } from '../../containers/TowingRecordPage/ViewTowingRecord/types'

export function toPrepaymentBoolean(value: unknown): boolean {
  return value === true || value === 1 || value === '1'
}

export function isRouteEditable(towingRecord: Pick<TowingRecord, 'status' | 'prepayment'>): boolean {
  const prepayment = toPrepaymentBoolean(towingRecord.prepayment)
  if (prepayment) {
    return (
      towingRecord.status === TowingRecordStatus.unfinished ||
      towingRecord.status === TowingRecordStatus.billing
    )
  }
  return towingRecord.status === TowingRecordStatus.unfinished
}
